export function parseBreadCrumbs(settings: { key: string; value: string }[]) {
    //todo: make regex dynamic
    const firstText = settings.find(entry => entry.key === 'breadcrumbtext1');
    const firstUrl = settings.find(entry => entry.key === 'breadcrumburl1');
    const secondText = settings.find(entry => entry.key === 'breadcrumbtext2');
    const secondUrl = settings.find(entry => entry.key === 'breadcrumburl2');

    return [
        { link: firstUrl?.value || '', name: firstText?.value || '' },
        { link: secondUrl?.value || '', name: secondText?.value || '' },
    ];
}
